import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgregar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "agregar",
		d: "M28,32H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H28a4,4,0,0,1,4,4V28A4.005,4.005,0,0,1,28,32ZM4,2A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2ZM16,23a1,1,0,0,1-1-1V17H10a1,1,0,0,1,0-2h5V10a1,1,0,0,1,2,0v5h5a1,1,0,1,1,0,2H17v5A1,1,0,0,1,16,23Z",
		fill: "#7fb02f"
	})]
});
const ForwardRef = forwardRef(SvgAgregar);
export { ForwardRef as ReactComponent };
